import React, {memo} from 'react';
import {ControlButton, TscButtonType, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import cssConstants from '../../constants/cssConstants';
import {IComment} from '../../model/commentModel';
import {useTranslation} from 'react-i18next';
import {CommentFooterWrapper} from '../util/StyledElements';

export const EditingCommentFooterBase: React.FC<IEditingCommentFooterProps> = ({isCommentOwner, comment, onSubmit, editedText, setShowDeleteAlertModal, deleteAnnotationOnSave, isReply, onCancel}) => {
   const {t} = useTranslation();

   return (
      <CommentFooterWrapper
         isCommentOwner={isCommentOwner}
         isReply={isReply}
         isEditing={true}
      >
         <ControlButton
            onClick={() => setShowDeleteAlertModal(true)}
            title={t('conversations.deleteComment')}
            glyph={<Glyphs.Delete16x16 />}
            testId="delete-comment-button"
            buttonType={TscButtonType.destructive}
            disabled={comment.isDeleted}
         />
         <ControlButton
            onClick={onCancel}
            title={t('conversations.cancelEdit')}
            label={t('general.cancel')}
            testId="cancel-editing-button"
            buttonType={TscButtonType.tertiary}
            width={cssConstants.smallButtonWidth}
         />
         <ControlButton
            onClick={() => onSubmit()}
            title={t('conversations.saveEdit')}
            label={t('general.save')}
            testId="save-edit-button"
            buttonType={TscButtonType.primary}
            width={cssConstants.smallButtonWidth}
            disabled={(comment.text === editedText && !deleteAnnotationOnSave) || comment.isResolved}
         />
      </CommentFooterWrapper>
   );
};

export interface IEditingCommentFooterProps {
   comment: IComment;
   editedText: string;
   deleteAnnotationOnSave: boolean;
   isReply: boolean;
   isCommentOwner: boolean;
   setShowDeleteAlertModal(showDeleteAlertModal: boolean): void;
   onSubmit(): void;
   onCancel(): void;
}

export default memo(EditingCommentFooterBase);
